// Copyright (c) 2016 Deere & Company

import PipCode, {getDefaultState} from '../state/pip-code';
import actions from '../../actions-list';

const addFile = (state, action) =>
    PipCode.update(state, {
        file: {
            $push: [action.data]
        }
    });

const updateFile = (state, action) =>
    PipCode.update(state, {
        file: {
            $set: action.files
        }
    });

const resetPipCode = (state, action) =>
    PipCode.update(state, {
        $set: action.data
    });

const updatePipCodeObject = (state, action) =>
    PipCode.update(state, {
        [action.name]: {
            $set: action.data
        }
    });

const updateWitness = (state, action) =>
    PipCode.update(state, {
        witness: {
            [action.name]: {
                $set: action.data
            }
        }
    });

const updatePipCode = (state, action) => {

    const paramTypes = {
        addFile,
        firstName: updateWitness,
        lastName: updateWitness,
        pipCodeType: updatePipCodeObject,
        postalDeliveryDate: updatePipCodeObject,
        postalTrackingNumber: updatePipCodeObject,
        reasonForRefusal: updatePipCodeObject,
        refusedDate: updatePipCodeObject,
        workOrderNumber: updatePipCodeObject
    };

    const reducerType = paramTypes[action.name];

    return reducerType(state, action);

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_PIP_CODE]: resetPipCode,
        [actions.UPDATE_PIP_CODE_OBJECT]: updatePipCode,
        [actions.UPDATE_PIP_CODE_FILE_LIST]: updateFile
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-code/reducers/pip-code-object.js